import _toConsumableArray from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.push.js";
import { createRouter, createWebHistory } from 'vue-router';

/* Layout */
import adminRoutes from './modules/admin';
import customersRoutes from './modules/customers';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export var constantRoutes = [{
  path: '/',
  redirect: '/auth-redirect'
}, {
  path: '/login-c',
  component: function component() {
    return import('@/views/auth/Login2C');
  },
  hidden: true
}, {
  path: '/login-b',
  component: function component() {
    return import('@/views/auth/Login2B');
  },
  hidden: true
}, {
  path: '/account-transfer',
  component: function component() {
    return import('@/views/auth/AccountTransfer');
  },
  hidden: true
}, {
  path: '/pass-reset',
  component: function component() {
    return import('@/views/auth/PassReset');
  },
  hidden: true
}, {
  path: '/pass-update',
  component: function component() {
    return import('@/views/auth/PassUpdate');
  },
  hidden: true
}, {
  path: '/forget-password',
  component: function component() {
    return import('@/views/auth/ForgetPassword');
  },
  hidden: true
}, {
  path: '/auth-redirect',
  component: function component() {
    return import('@/views/auth/auth-redirect');
  },
  hidden: true
}, {
  path: '/azure-redirect',
  component: function component() {
    return import('@/views/auth/azure-redirect');
  },
  hidden: true
}, {
  path: '/403',
  component: function component() {
    return import('@/views/error-page/403');
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/error-page/404');
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return import('@/views/error-page/401');
  },
  hidden: true
}, {
  path: '/environment',
  component: function component() {
    return import('@/views/environment');
  },
  hidden: true
},
// {
//   path: '/lasso/test',
//   component: () => import('@/views/lasso/test'),
//   hidden: true
// },
{
  path: '/lasso/callback',
  component: function component() {
    return import('@/views/lasso/callback');
  },
  hidden: true
}, {
  path: '/temporarily',
  component: function component() {
    return import('@/views/customers/temporarily');
  },
  hidden: true,
  children: [
    // {
    //   path: '',
    //   // hidden: true,
    //   component: resolve => require(['@/views/customers/temporarily'], resolve),
    //   name: 'temporarily'
    // },
    // {
    //   path: 'detail',
    //   component: resolve => require(['@/views/customers/temporarily/detail'], resolve),
    //   name: 'temporarily-detail',
    //   hidden: true
    // }
  ]
}, {
  path: '/temporarily/detail',
  component: function component() {
    return import('@/views/customers/temporarily/detail');
  },
  hidden: true
}, {
  path: '/page-pdf',
  component: function component() {
    return import('@/views/pdf');
  },
  hidden: true
}];
if (process.env.VUE_APP_ENV !== 'production') {
  constantRoutes.push({
    path: '/login-bb',
    component: function component() {
      return import('@/views/auth/Login2BInput');
    },
    hidden: true
  });
}

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export var asyncRoutes = [].concat(_toConsumableArray(customersRoutes), _toConsumableArray(adminRoutes));
var router = createRouter({
  history: createWebHistory(),
  scrollBehavior: function scrollBehavior() {
    return {
      top: 0
    };
  },
  routes: constantRoutes
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter({
    history: createWebHistory(),
    routes: constantRoutes
  });
  router.matcher = newRouter.matcher; // reset router
}
export var HOME_ADMIN = '/customs-clearance/export/export-d';
export var HOME_CUSTOMER = '/customs-clearance-supply/export/export-d';
export var WELCOME_CUSTOMER = '/customer-welcome/';
export var WELCOME_ADMIN = '/admin-welcome/';
export var HOME_CUSTOMER_INFO = '/customers-center';
export default router;